"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateAbbreviations = void 0;
var StateAbbreviations;
exports.StateAbbreviations = StateAbbreviations;

(function (StateAbbreviations) {
  StateAbbreviations["AL"] = "al";
  StateAbbreviations["AK"] = "ak";
  StateAbbreviations["AZ"] = "az";
  StateAbbreviations["AR"] = "ar";
  StateAbbreviations["CA"] = "ca";
  StateAbbreviations["CO"] = "co";
  StateAbbreviations["CT"] = "ct";
  StateAbbreviations["DE"] = "de";
  StateAbbreviations["FT"] = "fl";
  StateAbbreviations["GA"] = "ga";
  StateAbbreviations["HI"] = "hi";
  StateAbbreviations["ID"] = "id";
  StateAbbreviations["IL"] = "il";
  StateAbbreviations["IN"] = "in";
  StateAbbreviations["IA"] = "ia";
  StateAbbreviations["KS"] = "ks";
  StateAbbreviations["KY"] = "ky";
  StateAbbreviations["LA"] = "la";
  StateAbbreviations["MA"] = "ma";
  StateAbbreviations["MD"] = "md";
  StateAbbreviations["ME"] = "me";
  StateAbbreviations["MI"] = "mi";
  StateAbbreviations["MN"] = "mn";
  StateAbbreviations["MO"] = "mo";
  StateAbbreviations["MS"] = "ms";
  StateAbbreviations["MT"] = "mt";
  StateAbbreviations["NC"] = "nc";
  StateAbbreviations["ND"] = "nd";
  StateAbbreviations["NE"] = "ne";
  StateAbbreviations["NH"] = "nh";
  StateAbbreviations["NJ"] = "nj";
  StateAbbreviations["NM"] = "nm";
  StateAbbreviations["NV"] = "nv";
  StateAbbreviations["NY"] = "ny";
  StateAbbreviations["OH"] = "oh";
  StateAbbreviations["OK"] = "ok";
  StateAbbreviations["OR"] = "or";
  StateAbbreviations["OTHER"] = "other";
  StateAbbreviations["PA"] = "pa";
  StateAbbreviations["RI"] = "ri";
  StateAbbreviations["SC"] = "sc";
  StateAbbreviations["SD"] = "sd";
  StateAbbreviations["TN"] = "tn";
  StateAbbreviations["TX"] = "tx";
  StateAbbreviations["UT"] = "ut";
  StateAbbreviations["VA"] = "va";
  StateAbbreviations["VI"] = "vi";
  StateAbbreviations["VT"] = "vt";
  StateAbbreviations["WA"] = "wa";
  StateAbbreviations["DC"] = "dc";
  StateAbbreviations["WV"] = "wv";
  StateAbbreviations["WI"] = "wi";
  StateAbbreviations["WY"] = "wy";
})(StateAbbreviations || (exports.StateAbbreviations = StateAbbreviations = {}));